import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import type { ProvidedTaxRefundMethod } from '@/features/jobs/info-gathering/supporting-item-input'

/**
 * Props for {@link PersonalRefundMethodInfoSupportingItemInput}.
 */
export type PersonalRefundMethodInfoSupportingItemInputProps =
  ModelProps<PersonalRefundMethodInfoSupportingItemInput> & {
    type: 'PersonalRefundMethodInfo'
  }

/**
 * Supporting item input for a personal tax refund method.
 */
export class PersonalRefundMethodInfoSupportingItemInput extends Model<PersonalRefundMethodInfoSupportingItemInput> {
  /**
   * The provided tax refund method, if any.
   */
  @observable.struct accessor provided: ProvidedTaxRefundMethod | null = null
}
